export enum LanguageEnum {
	EN = 'EN',
	ZH_CN = 'ZH_CN',
}

export default LanguageEnum;
